/**
 * Block pinch / Safari gesture zoom on touch tablets (signage kiosk).
 * Viewport meta (`maximum-scale=1`) is the primary control; this covers WebKit
 * gesture events that still fire on some iOS / WebView builds.
 */
export function installMobilePageZoomSuppression(): void {
  if (typeof document === 'undefined') {
    return
  }
  const block = (event: Event) => {
    event.preventDefault()
  }
  document.addEventListener('gesturestart', block, { passive: false })
  document.addEventListener('gesturechange', block, { passive: false })
  document.addEventListener('gestureend', block, { passive: false })
  // Chrome / Android: ctrl+wheel (trackpad pinch) and multi-touch wheel zoom.
  document.addEventListener(
    'wheel',
    (event) => {
      if (event.ctrlKey) {
        event.preventDefault()
      }
    },
    { passive: false }
  )
}
